import { render, staticRenderFns } from "./ClinicianPatientAlerts.vue?vue&type=template&id=56f1b808"
import script from "./ClinicianPatientAlerts.vue?vue&type=script&lang=js"
export * from "./ClinicianPatientAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports